import React, { useRef, useState } from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './HeaderWithMenu.module.css';
import SearchSortFilterMenu from '../SearchSortFilterMenu/SearchSortFilterMenu';
import { columnProptype } from '../Table/types';

const HeaderWithMenu = ({
	column,
	field,
	rows,
	selectedFilterOptions,
	renderSortingHeader,
	...args
}) => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const ref = useRef(null);

	const uniqueFilterOptions = column.customFilterOptions
		? new Set(column.customFilterOptions)
		: new Set(rows.map((row) => row[field]).filter((i) => i));

	return (
		<>
			<div className={styles.headerWithMenu}>
				
				<FilterListIcon
					className={clsx(
						styles.filterIcon,
						(selectedFilterOptions?.length > 0 ||
							selectedFilterOptions?.size ||
							isMenuOpen) &&
							styles.openFilterIcon,
					)}
					onClick={() => setIsMenuOpen(true)}
					ref={ref}
					aria-label={`menu-for-column-${column.title}`}
				/>
				{column.sortable && <span style={{marginLeft:'1rem'}}>{renderSortingHeader(column)}</span>}
			</div>
			{isMenuOpen && (
				<SearchSortFilterMenu
					open={isMenuOpen}
					anchorEl={ref.current}
					handleClose={() => setIsMenuOpen(false)}
					enableSearch={column.enableSearch}
					enableFilter={column.enableFilter}
					filterOptions={[...uniqueFilterOptions]}
					selectedFilterOptions={selectedFilterOptions}
					searchLabel={column.title}
					{...args}
				/>
			)}
		</>
	);
};

HeaderWithMenu.propTypes = {
	column: columnProptype,
	field: PropTypes.string.isRequired,
	rows: PropTypes.array,
	selectedFilterOptions: PropTypes.objectOf(Set),
	sortState: PropTypes.oneOf(['ASCENDING', 'DESCENDING', 'UNSORTED']),
	applySort: PropTypes.func.isRequired,
};

export default HeaderWithMenu;
